export const generateId = (prefix: string, suffix: string): string => {
  return `${prefix}-${suffix}`
}
